<figure [innerHtml]="sanitizer.bypassSecurityTrustHtml(svg)"></figure>
<button type="button" itButton="primary" (click)="download()">
	{{ "it.general.download" | translate }}
</button>
